export const ExperimentsConsts = {
  WixTipsMatchCurrencyWithEcom: 'specs.bookings.WixTipsMatchCurrencyWithEcom',
};
